const state = {
  loading: false,
  isAuthenticated: false,
  lang: 'en',
  user: {},
  console: 'psn',
  menuPrimaryTournament: '',
  menuPrimaryDivision: '',
  menuPrimaryTeam: '',
  menuPrimaryUser: '',
  products: {
    data: []
  }
}

const getters = {
  products (state) {
    return state.products
  },
  console (state) {
    return state.console
  },
  isAdmin (state) {
    return state.isAdmin
  },
  user (state) {
    return state.user
  },
  lang (state) {
    return state.lang
  },
  loading (state) {
    return state.loading
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  },
  menuPrimaryTournament (state) {
    return state.menuPrimaryTournament
  },
  menuPrimaryDivision (state) {
    return state.menuPrimaryDivision
  },
  menuPrimaryTeam(state) {
    return state.menuPrimaryTeam
  },
  menuPrimaryUser(state) {
    return state.menuPrimaryUser
  }
}

const mutations = {
  SET_DELETE_PRODUCT(state, payload) {
    state.products.data = state.products.data.filter(p => {
      return p.id !== payload
    })
  },
  SET_PRODUCTS(state, payload) {
    state.products = payload
  },
  SET_UPDATE_MY_MONEY (state, payload) {
    state.user.money = payload
  },
  SET_USER (state, payload) {
    state.user = payload
  },
  SET_CONSOLE (state, payload) {
    state.console = payload
  },
  SET_LANG (state, payload) {
    state.lang = payload
  },
  SET_LOADING (state, payload) {
    state.loading = payload
  },
  SET_AUTHENTICATED (state, payload) {
    state.isAuthenticated = payload
  },
  SET_MENU_PRIMARY_TOURNAMENT (state, payload) {
    state.menuPrimaryTournament = payload
  },
  SET_MENU_PRIMARY_DIVISION(state, payload) {
    state.menuPrimaryDivision = payload
  },
  SET_MENU_PRIMARY_TEAM(state, payload) {
    state.menuPrimaryTeam = payload
  },
  SET_MENU_PRIMARY_USER(state, payload) {
    state.menuPrimaryUser = payload
  }
}

const actions = {
  SET_DELETE_PRODUCT (context, payload) {
    context.commit('SET_DELETE_PRODUCT', payload)
  },
  SET_PRODUCTS (context, payload) {
    context.commit('SET_PRODUCTS', payload)
  },
  SET_UPDATE_MY_MONEY (context, payload) {
    context.commit('SET_UPDATE_MY_MONEY', payload)
  },
  SET_CONSOLE (context, payload) {
    context.commit('SET_CONSOLE', payload)
  },
  SET_USER (context, payload) {
    context.commit('SET_USER', payload)
  },
  SET_LANG (context, payload) {
    context.commit('SET_LANG', payload)
  },
  SET_LOADING (context, payload) {
    context.commit('SET_LOADING', payload)
  },
  SET_AUTHENTICATED (context, payload) {
    context.commit('SET_AUTHENTICATED', payload)
  },
  SET_MENU_PRIMARY_TOURNAMENT (context, payload) {
    context.commit('SET_MENU_PRIMARY_TOURNAMENT', payload)
  },
  SET_MENU_PRIMARY_DIVISION(context, payload) {
    context.commit('SET_MENU_PRIMARY_DIVISION', payload)
  },
  SET_MENU_PRIMARY_TEAM(context, payload) {
    context.commit('SET_MENU_PRIMARY_TEAM', payload)
  },
  SET_MENU_PRIMARY_USER(context, payload) {
    context.commit('SET_MENU_PRIMARY_USER', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
